<template>
    <FullFillBox
        :pageID="5"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
        }"
    >
        <div v-if="wrongMode === true">
            <h2 class="error-text">{{ $t('error_not_found') }}</h2>
        </div>
        <div v-else>
            <h4><span style="font-size: 15px">{{ $t('stock_take_detail_add') }}</span> : {{ stockTakeMain.name }}
                <span style="font-size: 15px"> ( {{ stockTakeMain.createTime }} )</span></h4>
            <hr>
            <form @submit.prevent="dataToTable">
                <FilterMainContentBox
                    ref="filterMainContentBox">
                    <FilterDetailContentBox
                        ref="filterDetailContentBox"
                        :mode="''"
                        :update-mode="this.updateMode"
                        @cancelUpdateMode="cancelUpdateMode"
                        @returnProductData="(getProduct) => {
                        if(getProduct.status === 0){
                            this.ctnQty = null
                        }else{
                            this.getComponentProduct = getProduct['details']
                            this.ctnQty = getProduct['details']['out_pack']
                        }
                        this.checkCanInputQty()
                    }"
                    >
                        <slot>
                            <LocationSearchBox
                                ref="locationSearchBox"
                                @loc="(value) => {
                                    this.getComponentLocation = value
                                    this.checkCanInputQty()
                                }"
                            />
                            <div class="row g-0">
                                <QtyProcessor
                                    ref="qtyProcessor"
                                    :flag="this.canInputNumber"
                                    :ctn-qty="this.ctnQty"
                                    @returnQty="(returnData)=>{
                                    this.getQty = returnData['qty']
                                    this.getCtn = returnData['ctn']
                                }"
                                />
                            </div>
                            <div class="row py-1">
                                <div class="col-md-2 col-form-label">{{ $t('table_remarks') }}</div>
                                <div class="col-md-10"><input class="form-control" type="text" v-model="getRemarks"></div>
                            </div>
                        </slot>
                    </FilterDetailContentBox>
                </FilterMainContentBox>
            </form>
            <hr>
            <div ref="tabulatorTableUse"></div>
            <button class="btn btn-primary"
                    @click="uploadToServer"
                    v-if="showAddButton"
                    style="width: 200px;margin: auto auto 5px auto">
                {{ $t('common_upload') }}
            </button>
            <div v-if="error_details.length > 0">
                <hr>
                <p  v-for="(value, key) in this.error_details">{{ key }} : {{ value }}</p>
            </div>
        </div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import FilterMainContentBox from "@/components/StockProcessComponents/FilterMainContentBox";
import FilterDetailContentBox from "@/components/StockProcessComponents/FilterDetailContentBox";
import QtyProcessor from "@/components/StockProcessComponents/QtyProcessor";
import ProductSearchBox from "@/components/ProductSearchBox";
import LocationSearchBox from "@/components/LocationSearchBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "StockTakeDetailsAddView",
    components: {
        FilterMainContentBox,
        FilterDetailContentBox,
        QtyProcessor,
        FullFillBox,
        ProductSearchBox,
        LocationSearchBox,
        Multiselect,
    },
    data(){
        return {
            permissionDetails: {},
            showAddButton: false,
            wrongMode: false,
            stockTakeMain: '',

            tablePKID: 1,

            updateMode: false,
            canInputNumber: false,
            ctnQty: null,
            getCtn: '',
            getQty: '',
            getRemarks: '',
            getComponentLocation: '',
            getComponentProduct: '',

            error_details: [],
        }
    },
    methods: {
        checkCanInputQty(){
            this.canInputNumber = !!(this.getComponentProduct.id && this.getComponentLocation.id);
        },
        async uploadToServer(){
            if(this.tabulator.getData().length === 0){
                this.$swal.fire({
                    title: this.$t('stock_take_detail_required'),
                })
            }else{
                // upload to server
                let returnData = {
                    "data": this.tabulator.getData(),
                    "main": this.stockTakeMain.id
                }
                await this.$mainApi.post('api/stock-take/stock-take-detail-details/', returnData)
                    .then(response => {
                        if(response.data.status === 80){
                            if(response.data.errors.error_row.length === 0){
                                // No errors
                                this.$toast.success(this.$t('common_success'))
                                this.$router.push(`/stock-take/details/${this.stockTakeMain.id}`)
                            }else{
                                this.$toast.error(this.$t('error_warning'))
                                this.tabulator.setData(response.data.details)
                                this.tabulator.setData(this.tabulator.getData().filter(a => response.data.errors.error_row.includes(a.id)))
                                this.error_details = response.data.errors.error_details
                            }
                        }
                    })
            }
        },
        dataToTable(){
            try{
                let data = this.tabulator.getData()
                if(this.getComponentProduct['id'] && this.getComponentLocation['id'] && this.getQty && this.getCtn){
                    // Check if given data is duplicate
                    let duplicateData = 0
                    if(this.updateMode === false){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.remarks === this.getRemarks)
                    }else if(this.updateMode === true){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.remarks === this.getRemarks &&
                            a.id !== this.updateItemID)
                    }

                    if(duplicateData === -1){
                        // No Same Data, add NEW
                        data.push({
                            "id": this.tablePKID,
                            "pid": this.getComponentProduct['id'],
                            "lid": this.getComponentLocation['id'],
                            "outCode": this.getComponentProduct['outCode'],
                            "innerCode": this.getComponentProduct['innerCode'],
                            "product_name": this.getComponentProduct['name_en'],
                            "location_name": this.getComponentLocation['label'],
                            "qty": this.getQty,
                            "ctn": this.getCtn,
                            "remarks": this.getRemarks,
                        })

                        // if update mode, add new then delete old myself
                        if(this.updateMode === true){
                            data = data.filter(a => a.id !== this.updateItemID)
                        }
                    }else if(duplicateData > -1){
                        // Has Same Data, update OLD
                        if(this.updateMode === true){
                            // update old data to new
                            let newData = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['label'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                            data[duplicateData] = {
                                ...data[duplicateData],
                                ...newData
                            }

                            // if update mode, add new then delete old myself
                            data = data.filter(a => a.id !== this.updateItemID)

                        }else if(this.updateMode === false){
                            // old data add new data (But no need delete myself, cuz no myself)
                            // let gotTheItem = false
                            data[duplicateData] = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['label'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                        }
                    }
                    this.tablePKID += 1
                    this.tabulator.setData(data)
                    this.clearInputData()
                    this.updateMode = false
                }else{
                    this.$swal.fire({
                        title: this.$t('error_input_stock_in_field_required'),
                        icon: "warning"
                    })
                }
            }catch(e){
                this.$swal.fire({
                    title: this.$t('error_input_stock_in_field_required'),
                    icon: "warning"
                })
            }
        },
        cancelUpdateMode(res){
            this.updateMode = false
            this.$refs.qtyProcessor.clearMode()
            this.clearInputData()
        },
        clearInputData(){
            this.getQty = ""
            this.getCtn = ""
            this.getRemarks = ""
            this.$refs.qtyProcessor.clearMode()
            this.canInputNumber = false
            this.$refs.filterDetailContentBox.resetProductSearch()
        },
        async checkIfCorrectID(getID){
            this.wrongMode = false
            await this.$mainApi.get(`api/stock-take/stock-take-main-check?id=${getID}`)
                .then(response => {
                    if(response.data.status === 80){
                        if(response.data.details.result === 0){
                            // Not Exist
                            this.wrongMode = true
                        }else if(response.data.details.result === 1){
                            this.stockTakeMain = response.data.details.details
                            this.wrongMode = false
                        }else{
                            this.wrongMode = true
                        }
                    }else{
                        this.wrongMode = true
                    }
                })
        }
    },
    watch: {
        '$route.params': {
            async handler(newStockTakeDetailID) {
                await this.checkIfCorrectID(newStockTakeDetailID.id)
            },
            immediate: true,
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('stock_take_manage')
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', maxWidth: 20, responsive: 0},
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: 'product_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location_name', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {field: 'id', visible: false},
                {field: 'pid', visible: false},
                {field: 'lid', visible: false},
                {
                    formatter: () => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.updateMode = true
                        this.updateItemID = row.getData().id
                        this.$refs.filterDetailContentBox.updateModeChange(row.getData().outCode)
                        this.$refs.locationSearchBox.updateMode(row.getData().lid)
                        this.$refs.qtyProcessor.updateModeOnQty({
                            "qty": row.getData().qty,
                            "ctn": row.getData().ctn
                        })
                        this.getQty = row.getData().qty
                        this.getCtn = row.getData().ctn
                        this.getRemarks = row.getData().remarks
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            title: this.$t('common_confirm_action_delete'),
                            icon: 'info'
                        }).then(result => {
                            if(result.isConfirmed){
                                let data = this.tabulator.getData()
                                data = data.filter(a => a.id !== row.getData().id)
                                this.tabulator.setData(data)
                            }
                        })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            height: 'auto',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            initialSort:[
                {column:"location", dir:"asc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().is_error === true){
                    row.getElement().style.backgroundColor = "#ffc7c7"
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
